<div class="atlas-form mct-gap-27 mct-grid mct-cols-1 mct-grid-gt-sm mct-cols-1-1-gt-sm banner-ad-layout" *ngIf="banner" ngModelGroup="banner">
  <div class="area-header">
    <div class="mct-flex mct-row" *ngIf="profile">
      <wl-profile-type-icon
        [isMember]="profile.Member"
        [isOrg]="profile.OrgInd"
        [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }"
        [profileId]="profile.ProfileId"
        [memberTypeIconColor]="profile.MemberTypeIconColor"
      ></wl-profile-type-icon>
      <h4>
        {{ profile.ReportName }} <span class="light-text">({{ profile.ProfileId }})</span>
      </h4>
    </div>
  </div>

  <div class="area-left">
    <div class="mb-27">
      <label>{{ 'banner-ads.edit.keyword' | translate | ucfirst }}</label>
      <input name="keyword" [(ngModel)]="banner.Keyword" />
    </div>
    <div>
      <label>{{ 'banner-ads.edit.image-alt-text' | translate | ucfirst }}</label>
      <input name="imageAltText" [(ngModel)]="banner.AlternateText" />
    </div>
  </div>

  <div class="area-right">
    <div class="mb-27">
      <label>{{ 'banner-ads.edit.banner-name' | translate | ucfirst }}</label>
      <input name="bannerName" [(ngModel)]="banner.BannerName" />
    </div>
    <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-gap-27">
      <div>
        <label>{{ 'banner-ads.edit.start-date' | translate | ucfirst }}</label>
        <wl-date-selector name="displayStartDate" [required]="true" appendTo="body" [(ngModel)]="banner.DisplayStartDate">
        </wl-date-selector>
      </div>
      <div>
        <label>{{ 'banner-ads.edit.end-date' | translate | ucfirst }}</label>
        <wl-date-selector
          name="displayEndDate"
          [required]="true"
          [(ngModel)]="banner.DisplayEndDate"
          [minDate]="banner.DisplayStartDate"
        ></wl-date-selector>
      </div>
    </div>
  </div>

  <div class="mct-flex mct-col mct-gap-27 area-bottom">
    <div>
      <label>{{ 'banner-ads.edit.select-an-image-in-the-system' | translate | ucfirst }}</label>
      <wl-image-lookup
        name="imageUrlLookup"
        [(ngModel)]="imageSelectorUrl"
        (onImageChanged)="onImageChangedOrSelected($event)"
        (onImageSelected)="onImageChangedOrSelected($event)"
      ></wl-image-lookup>
    </div>
    <div>
      <label>{{ 'banner-ads.edit.image-url' | translate | ucfirst }}</label>
      <input required name="imageUrl" [(ngModel)]="banner.ImageUrl" />
    </div>
    <div>
      <label>{{ 'banner-ads.edit.navigate-to-this-url-when-clicked' | translate | ucfirst }}</label>
      <input name="navigateUrl" [(ngModel)]="banner.NavigateUrl" />
    </div>
  </div>
</div>
